export const featureFlagsReducer = (state = {}, action) => {
	switch (action.type) {
		default:
			return state;
	}
};
